import { AuthService } from './services/auth.service';
import { AppService } from './services/app.service';
import { Component } from '@angular/core';
import { ThemeService } from './services/theme.service';
import { iThemeTypes } from './interfaces/themes.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  showLogin = true;
  loginByToken: string | null = "";

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this.loginByToken = sessionStorage.getItem('loginByToken');
    this.authService.showLoginEmmiter.subscribe((s) => {
      this.showLogin = s;
    });

    const applyNoTranslateToIcons = () => {
      const materialIcons = document.querySelectorAll('i.material-icons');
      materialIcons.forEach((el) => {
        el.classList.add('notranslate');
        el.setAttribute('translate', 'no');
      });
    };
    applyNoTranslateToIcons();

    const observer = new MutationObserver(() => {
      applyNoTranslateToIcons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const systemType = sessionStorage.getItem('systemType') as iThemeTypes;
    if (systemType) {
      this.themeService.setTheme(systemType as iThemeTypes);
    } else {
      this.themeService.setTheme('SAFEGIS');
    }
  }

  ngOnChanges(): void {
    const systemType = sessionStorage.getItem('systemType') as iThemeTypes;
    if (systemType) {
      this.themeService.setTheme(systemType as iThemeTypes);
    } else {
      this.themeService.setTheme('SAFEGIS');
    }
  }

  getClasses() {
    const classes = {
      active: this.appService.getSidebarStat().isSidebarPinned,
      'toggeled-sidebar': this.appService.getSidebarStat().isSidebarToggeled,
    };
    return classes;
  }
}
